/**
 * Gescheiterte Dankmail nach Anzahlung/Vollzahlung (sql/718, Antoine 14.10.2026: kein Auto-Retry,
 * der Fehler steht am Vorgang, ein Knopf versendet erneut). Zeigt je Zahlung mit
 * `dankMailFehler` den Grund und „Dankmail erneut senden" (POST /api/payments/:id/dank-mail-erneut).
 */
import { useState } from "react";
import { Button, Icon, MailFehlerHinweis } from "../components";
import { money, PAYMENT_TYPE_LABEL } from "../format";
import type { Payment } from "../types";

export function DankmailFehler({ payments, onErneutSenden }: { payments: Payment[]; onErneutSenden: (p: Payment) => Promise<void> }) {
  const [busy, setBusy] = useState<string | null>(null);
  const [fehler, setFehler] = useState<string | null>(null);
  const betroffen = payments.filter((p) => p.dankMailFehler);
  if (betroffen.length === 0) return null;

  async function senden(p: Payment) {
    setBusy(p.id);
    setFehler(null);
    try {
      await onErneutSenden(p);
    } catch (err) {
      setFehler(err instanceof Error ? err.message : String(err));
    } finally {
      setBusy(null);
    }
  }

  return (
    <ul className="space-y-2" aria-label="Nicht verschickte Dankmails" data-testid="dankmail-fehler">
      {betroffen.map((p) => (
        <li
          key={p.id}
          className="flex flex-col gap-2 rounded-lg border border-outline-variant/30 p-2.5 sm:flex-row sm:items-start sm:justify-between dark:border-outline/30"
        >
          <div className="min-w-0">
            <p className="font-body-sm text-[12px] font-semibold text-on-background dark:text-inverse-on-surface">
              Dankmail zu {PAYMENT_TYPE_LABEL[p.paymentType] ?? "Zahlung"} · {money(p.amountCents)} nicht verschickt
            </p>
            <MailFehlerHinweis rawError={p.dankMailFehler!} />
            {fehler && busy === null && <p className="mt-1 font-body-sm text-[11.5px] text-error">{fehler}</p>}
          </div>
          <Button type="button" variant="secondary" className="!py-1.5 !text-[11.5px]" disabled={busy !== null} onClick={() => void senden(p)}>
            <Icon name="send" className="text-[15px]" /> {busy === p.id ? "Wird gesendet …" : "Dankmail erneut senden"}
          </Button>
        </li>
      ))}
    </ul>
  );
}
